var map = {
	"./EYEBROWS1.svg": 78791,
	"./EYEBROWS10.svg": 3219,
	"./EYEBROWS11.svg": 25078,
	"./EYEBROWS2.svg": 40072,
	"./EYEBROWS3.svg": 88332,
	"./EYEBROWS4.svg": 53253,
	"./EYEBROWS5.svg": 68749,
	"./EYEBROWS6.svg": 48722,
	"./EYEBROWS7.svg": 50815,
	"./EYEBROWS8.svg": 63814,
	"./EYEBROWS9.svg": 78251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98672;